import { useEffect, useMemo } from "react";
import SellerCard from "../../components/SellerCard";
import { Skeleton } from "boneyard-js/react";
import { usePersistStore, useStore } from "../../store";
import { Seller } from "../../types";
import { useFollowingList } from "../../hooks/queries";

function Following() {
  const { token, currentLocation } = usePersistStore((s: any) => s);
  const { setErrorMessage } = useStore((s: any) => s);
  // Keyed under ["follows"], so follow/unfollow mutations (which invalidate
  // ["follows"]) keep this list in sync without a manual refetch.
  const { data = [], isLoading, error } = useFollowingList(
    token,
    currentLocation
  );
  const isReady = !isLoading;

  useEffect(() => {
    if (error) setErrorMessage((error as Error).message);
  }, [error, setErrorMessage]);

  const list: Seller[] = useMemo(
    () =>
      (data || []).map((u: any) => ({
        _id: u?._id,
        name: u?.name,
        imageUrl: u?.fileUrl,
        sold: u?.salesCount ?? 0,
        distance: u?.distance,
        profileUrl: `/seller/${u?._id}`,
        city: u?.city,
        state: u?.state,
        speciality: u?.speciality,
        badges: u?.badges || [],
      })),
    [data]
  );

  return (
    <div className="bg-pink p-4">
      <div className="row">
        <div className="col-12">
          <h2 className="m-0">Following</h2>
        </div>
      </div>
      <div className="row mt-4 justify-content-start">
        {!isReady &&
          Array.from({ length: 6 }).map((_, i) => (
            <div
              key={`sk-${i}`}
              className="custom-col sellerCardCol mb-sm-4"
            >
              <Skeleton name="seller-card" loading={true}>
                <span style={{ display: "block", minHeight: 220 }} />
              </Skeleton>
            </div>
          ))}
        {isReady && list.length === 0 && (
          <div className="col-12">You're not following anyone yet.</div>
        )}
        {isReady &&
          list.map((seller: Seller, index: number) => (
            <SellerCard seller={seller} key={index} showFollowButton={true} />
          ))}
      </div>
    </div>
  );
}

export default Following;
